(() => {
  const configNode = document.getElementById('CoffeeSystemConfig');
  if (!configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    console.error('Nie udało się odczytać konfiguracji Postaw kawę.', error);
    return;
  }

  let coffeeVariantIds = [Number(config.espressoVariantId), Number(config.latteVariantId)].filter(Boolean);

  const request = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...options,
    });
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || body.message || 'Nie udało się zaktualizować koszyka.');
    return body;
  };

  const getCart = () => request(`${config.cartUrl}.js`);

  let configurationPromise;
  const ensureConfiguration = async () => {
    if (config.configured && coffeeVariantIds.length === 2) return config;
    if (configurationPromise) return configurationPromise;
    if (!config.productJsonUrl) throw new Error('W ustawieniach motywu wybierz produkt „Postaw kawę dla Edukowo ☕”.');

    configurationPromise = fetch(config.productJsonUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Nie udało się odczytać wariantów produktu kawy.');
        return response.json();
      })
      .then((product) => {
        const variants = product.variants || [];
        const espresso =
          variants.find((variant) => String(variant.title).toLowerCase().includes('espresso')) ||
          variants.find((variant) => Number(variant.price) === 1000) ||
          variants[0];
        const latte =
          variants.find((variant) => String(variant.title).toLowerCase().includes('latte')) ||
          variants.find((variant) => Number(variant.price) === 2000) ||
          variants[1];
        if (!espresso?.id || !latte?.id || espresso.id === latte.id) {
          throw new Error('Produkt kawy powinien mieć dwa warianty: Espresso i Latte.');
        }
        config.espressoVariantId = Number(espresso.id);
        config.latteVariantId = Number(latte.id);
        config.configured = true;
        coffeeVariantIds = [config.espressoVariantId, config.latteVariantId];
        document.querySelectorAll('[data-coffee-kind="espresso"]').forEach((button) => {
          button.dataset.coffeeVariantId = String(config.espressoVariantId);
          button.disabled = false;
        });
        document.querySelectorAll('[data-coffee-kind="latte"]').forEach((button) => {
          button.dataset.coffeeVariantId = String(config.latteVariantId);
          button.disabled = false;
        });
        return config;
      });

    return configurationPromise;
  };

  const coffeeUpdates = (cart, selectedVariantId = 0) => {
    const updates = {};
    cart.items.forEach((item) => {
      if (coffeeVariantIds.includes(Number(item.variant_id)) || item.properties?._coffee_system === 'true') {
        updates[item.key] = 0;
      }
    });
    if (selectedVariantId) updates[String(selectedVariantId)] = 1;
    return updates;
  };

  const replaceCoffee = async (selectedVariantId = 0) => {
    if (selectedVariantId && !coffeeVariantIds.includes(Number(selectedVariantId))) {
      throw new Error('Nieprawidłowy wariant kawy.');
    }
    const cart = await getCart();
    const updates = coffeeUpdates(cart);
    if (Object.keys(updates).length) {
      await request(config.updateUrl, { method: 'POST', body: JSON.stringify({ updates }) });
    }
    if (selectedVariantId) {
      await request(config.addUrl, {
        method: 'POST',
        body: JSON.stringify({
          items: [{ id: Number(selectedVariantId), quantity: 1, properties: { _coffee_system: 'true' } }],
        }),
      });
    }
  };

  const materialVariantFromButton = (button) => {
    const formId = button.dataset.coffeeMaterialForm;
    const form = formId ? document.getElementById(formId) : null;
    return Number(form?.querySelector('[name="id"]')?.value || 0);
  };

  const addMaterial = async (button) => {
    if (button.dataset.coffeeKind) await ensureConfiguration();
    const materialVariantId = materialVariantFromButton(button);
    const materialType = button.dataset.coffeeMaterialType;
    const coffeeVariantId = Number(button.dataset.coffeeVariantId || 0);
    if (!materialVariantId) throw new Error('Wybierz dostępny wariant materiału.');
    if (materialType === 'required' && !coffeeVariantId) throw new Error('Wybierz Espresso lub Latte.');
    if (coffeeVariantId && !config.configured) throw new Error('Najpierw wybierz produkt kawy w ustawieniach motywu.');

    if (coffeeVariantId) await replaceCoffee(coffeeVariantId);

    const properties = materialType === 'required'
      ? { _coffee_required: 'true' }
      : { _coffee_optional: 'true' };
    await request(config.addUrl, {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: materialVariantId, quantity: 1, properties }] }),
    });
  };

  const setLoading = (scope, loading) => {
    scope?.classList.toggle('coffee-is-loading', loading);
    scope?.querySelectorAll('button').forEach((button) => {
      button.disabled = loading;
    });
  };

  const showMessage = (scope, message, isError = false) => {
    const target = scope?.querySelector('[data-coffee-message]');
    if (!target) return;
    target.textContent = message;
    target.classList.toggle('coffee-system-message--error', isError);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-coffee-action]');
    if (!button) return;
    event.preventDefault();

    const scope = button.closest('[data-coffee-product-actions], [data-coffee-cart-gate]');
    setLoading(scope, true);
    showMessage(scope, 'Aktualizuję koszyk…');

    try {
      if (button.dataset.coffeeAction === 'add-material') {
        await addMaterial(button);
      } else if (button.dataset.coffeeAction === 'set-coffee') {
        await ensureConfiguration();
        await replaceCoffee(Number(button.dataset.coffeeVariantId));
      } else if (button.dataset.coffeeAction === 'remove-coffee') {
        await replaceCoffee(0);
      }
      window.location.assign(config.cartUrl);
    } catch (error) {
      showMessage(scope, error.message, true);
      setLoading(scope, false);
    }
  });

  const cartRequiresCoffee = (cart) =>
  cart.items.some((item) => item.properties?._coffee_required === 'true');
  const cartHasCoffee = (cart) =>
    cart.items.some(
      (item) =>
        coffeeVariantIds.includes(Number(item.variant_id)) ||
        item.properties?._coffee_system === 'true'
    );

  let checkoutInProgress = false;
  ensureConfiguration().catch((error) => {
    document.querySelectorAll('[data-coffee-product-actions], [data-coffee-cart-gate]').forEach((scope) => {
      showMessage(scope, error.message, true);
    });
  });

  document.addEventListener(
    'click',
    async (event) => {
      const checkout = event.target.closest('[name="checkout"]');
      if (!checkout || checkoutInProgress) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        const cart = await getCart();
        if (cartRequiresCoffee(cart) && !cartHasCoffee(cart)) {
          const gate = document.querySelector('[data-coffee-cart-gate]');
          gate?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          showMessage(gate, 'Wybierz Espresso lub Latte, aby przejść dalej.', true);
          return;
        }
        checkoutInProgress = true;
        window.location.assign('/checkout');
      } catch (error) {
        alert(error.message);
      }
    },
    true
  );
})();
